webpackJsonp([22],{

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReviewAvgRatingScss = __webpack_require__(971);
	
	var _ReviewAvgRatingScss2 = _interopRequireDefault(_ReviewAvgRatingScss);
	
	var _componentsStarRating = __webpack_require__(219);
	
	var _componentsStarRating2 = _interopRequireDefault(_componentsStarRating);
	
	var _decoratorsConnectToStores = __webpack_require__(161);
	
	var _decoratorsConnectToStores2 = _interopRequireDefault(_decoratorsConnectToStores);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var ReviewAvgRating = (function (_React$Component) {
	    _inherits(ReviewAvgRating, _React$Component);
	
	    function ReviewAvgRating() {
	        _classCallCheck(this, _ReviewAvgRating);
	
	        _get(Object.getPrototypeOf(_ReviewAvgRating.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(ReviewAvgRating, [{
	        key: 'render',
	        value: function render() {
	            var rating = this.props.rating;
	            var showLabel = this.props.showLabel;
	
	            if (showLabel) {
	                return {
	                    $$typeof: _typeofReactElement,
	                    type: 'div',
	                    key: null,
	                    ref: null,
	                    props: {
	                        children: [{
	                            $$typeof: _typeofReactElement,
	                            type: _componentsStarRating2['default'],
	                            key: null,
	                            ref: null,
	                            props: _defaultProps(_componentsStarRating2['default'].defaultProps, {
	                                value: rating
	                            }),
	                            _owner: null
	                        }, {
	                            $$typeof: _typeofReactElement,
	                            type: 'span',
	                            key: null,
	                            ref: null,
	                            props: {
	                                children: ["Рейтинг", ' ', rating],
	                                className: (0, _ReviewAvgRatingScss2['default'])('label')
	                            },
	                            _owner: null
	                        }]
	                    },
	                    _owner: null
	                };
	            } else {
	                return {
	                    $$typeof: _typeofReactElement,
	                    type: 'div',
	                    key: null,
	                    ref: null,
	                    props: {
	                        children: {
	                            $$typeof: _typeofReactElement,
	                            type: _componentsStarRating2['default'],
	                            key: null,
	                            ref: null,
	                            props: _defaultProps(_componentsStarRating2['default'].defaultProps, {
	                                value: rating
	                            }),
	                            _owner: null
	                        }
	                    },
	                    _owner: null
	                };
	            }
	        }
	    }], [{
	        key: 'propTypes',
	        value: {
	            rating: _react.PropTypes.number.isRequired,
	            coachId: _react.PropTypes.number.isRequired,
	            showLabel: _react.PropTypes.bool
	        },
	        enumerable: true
	    }, {
	        key: 'defaultProps',
	        value: {
	            showLabel: true
	        },
	        enumerable: true
	    }]);
	
	    var _ReviewAvgRating = ReviewAvgRating;
	    ReviewAvgRating = (0, _decoratorsConnectToStores2['default'])({
	        ratings: function ratings(_ref, props) {
	            var state = _ref.state;
	            return {
	                rating: props.rating ? props.rating : Number(state.ratings[props.coachId].rating)
	            };
	        }
	    })(ReviewAvgRating) || ReviewAvgRating;
	    ReviewAvgRating = (0, _decoratorsWithStyles2['default'])(_ReviewAvgRatingScss2['default'])(ReviewAvgRating) || ReviewAvgRating;
	    return ReviewAvgRating;
	})(_react2['default'].Component);
	
	exports['default'] = ReviewAvgRating;
	module.exports = exports['default'];

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(972);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(973);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewAvgRating.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewAvgRating.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._2noDylLw2E{font-size:9pt;display:inline-block;margin-left:5px;vertical-align:middle;color:#fff}@media (max-width:850px){._2noDylLw2E{display:block;margin-left:0;margin-top:5px}}", ""]);
	
	// exports
	exports.locals = {
		"label": "_2noDylLw2E"
	};

/***/ })

});


// WEBPACK FOOTER //
// 22.uk.22-9385fff643c2fb5ded20-built.js